import React from "react";
import bgimage3 from "../../Assest/bgimage3.avif";
import { Award, Users } from "lucide-react";

export default function AboutUs() {
  return (
    <section id="aboutus" className="w-full py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="bl-container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Section */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-600 to-purple-600 rounded-2xl transform rotate-3 group-hover:rotate-6 transition-transform duration-300"></div>
            <img 
              src={bgimage3} 
              alt="About Our Tech" 
              className="relative w-full h-auto rounded-2xl shadow-2xl transform -rotate-3 group-hover:-rotate-6 transition-transform duration-300 object-cover"
            />
          </div>

          {/* Content Section */}
          <div className="space-y-8">
            {/* Header */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                About Our
                <span className="block text-blue-600">Tech Excellence</span>
              </h2>
              <div className="w-20 h-1 bg-blue-600 mb-6"></div>
            </div>

            {/* Description */}
            <div className="space-y-6">
              <p className="text-lg text-gray-600 leading-relaxed">
                We are a results-driven consultancy focused on helping businesses
                grow, adapt, and lead in a fast-changing world. Backed by
                experienced professionals and industry insights, we deliver
                tailored strategies that unlock value and drive innovation.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed">
                Our mission is to go beyond advice—partnering with clients to
                create real, measurable impact. From startups to enterprises, we
                build long-term relationships rooted in trust, clarity, and
                sustainable success.
              </p>
            </div>

            {/* Statistics Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12">
              <div className="group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors duration-300">
                    <Award className="w-6 h-6 text-blue-600" />
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">500+</h3>
                <p className="text-gray-600 font-medium">Successful Projects</p>
                <div className="w-full bg-gray-200 rounded-full h-2 mt-3">
                  <div className="bg-blue-600 h-2 rounded-full w-3/4"></div>
                </div>
              </div>

              <div className="group bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="p-3 bg-green-50 rounded-lg group-hover:bg-green-100 transition-colors duration-300">
                    <Users className="w-6 h-6 text-green-600" />
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">1000+</h3>
                <p className="text-gray-600 font-medium">Workforce Solutions</p>
                <div className="w-full bg-gray-200 rounded-full h-2 mt-3">
                  <div className="bg-green-600 h-2 rounded-full w-4/5"></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
